export const EXAM_TYPE_EGE = 1;
export const EXAM_INNER_TEST = 2;
export const EXAM_MEDIUM_BALL_FROM_DOC = 3;
export const EXAM_ACCREDITATION = 4;
export const EXAM_GIA = 5;
export const EXAM_RIGHT_ON_MAX_POINTS = 6;
